<script setup lang="ts">
import { Dropdown } from 'flowbite';
import type { DropdownInterface } from 'flowbite';
import flagGB from '~/assets/svg/flag-gb.svg?url';
import flagSE from '~/assets/svg/flag-se.svg?url';
import flagDE from '~/assets/svg/flag-de.svg?url';
import flagPT from '~/assets/svg/flag-pt.svg?url';

let dropdown: DropdownInterface;

onMounted(() => {
    dropdown = new Dropdown(
        document.getElementById('dropdownMenu'),
        document.getElementById('dropdownToggle'),
    );
});

const countryValue: { value: string | undefined } = defineModel();

const phonePrefixes: { [key: string]: { name: string; icon: string } } = {
    SE: { name: '+46', icon: flagSE },
    DE: { name: '+49', icon: flagDE },
    PT: { name: '+351', icon: flagPT },
    GB: { name: '+44', icon: flagGB },
};

const phonePrefix = computed(() => {
    if (countryValue.value && countryValue.value in phonePrefixes) {
        return phonePrefixes[countryValue.value];
    } else {
        return phonePrefixes.SE;
    }
});

function selectPrefix(prefix: string) {
    countryValue.value = prefix;
    dropdown.hide();
}
</script>

<template>
    <button
        id="dropdownToggle"
        type="button"
        class="flex-shrink-0 z-10 inline-flex items-center py-2.5 px-4 text-sm font-medium text-center text-gray-500 bg-gray-100 border border-gray-300 rounded-l-lg hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700 dark:text-white dark:border-gray-600"
    >
        <img class="h-5 w-5 mr-2" :src="phonePrefix.icon" alt="phone" />
        <svg
            class="ml-1 w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 9l-7 7-7-7"
            ></path>
        </svg>
    </button>

    <div id="dropdownMenu" class="hidden phone-prefix-dropdown-area">
        <ul class="py-1" role="none">
            <li>
                <a
                    href="#"
                    class="phone-prefix-dropdown-item"
                    role="menuitem"
                    @click="selectPrefix('GB')"
                >
                    <div class="flex justify-between">
                        <div class="inline-flex items-center">
                            <img class="h-3.5 w-3.5 mr-2" :src="flagGB" alt="GB flag"/>
                            United Kingdom
                        </div>
                        <div>+44</div>
                    </div>
                </a>
            </li>
            <li>
                <a
                    href="#"
                    class="phone-prefix-dropdown-item"
                    role="menuitem"
                    @click="selectPrefix('DE')"
                >
                    <div class="flex justify-between">
                        <div class="inline-flex items-center">
                            <img class="h-3.5 w-3.5 mr-2" :src="flagDE" alt="DE flag"/>
                            Germany
                        </div>
                        <div>+49</div>
                    </div>
                </a>
            </li>
            <li>
                <a
                    href="#"
                    class="phone-prefix-dropdown-item"
                    role="menuitem"
                    @click="selectPrefix('SE')"
                >
                    <div class="flex justify-between">
                        <div class="inline-flex items-center">
                            <img class="h-3.5 w-3.5 mr-2" :src="flagSE" alt="SE flag"/>
                            Sweden
                        </div>
                        <div>+46</div>
                    </div>
                </a>
            </li>
            <li>
                <a
                    href="#"
                    class="phone-prefix-dropdown-item"
                    role="menuitem"
                    @click="selectPrefix('PT')"
                >
                    <div class="flex justify-between">
                        <div class="inline-flex items-center">
                            <img class="h-3.5 w-3.5 mr-2" :src="flagPT" alt="PT flag"/>
                            Portugal
                        </div>
                        <div>+351</div>
                    </div>
                </a>
            </li>
        </ul>
    </div>
</template>

<style scoped>
.phone-prefix-dropdown {
    @apply text-gray-800 dark:text-gray-300 hover:bg-gray-50 focus:ring-gray-300 font-medium rounded-lg text-sm px-2.5 lg:px-5 py-2.5 mr-2 dark:hover:bg-gray-800;
}

.phone-prefix-dropdown-footer {
    @apply text-gray-300 focus:ring-gray-300 font-medium rounded-lg text-sm px-2.5 lg:px-5 py-2.5 mr-2 hover:bg-gray-800;
}

.phone-prefix-dropdown-area {
    @apply z-50 my-4 w-48 text-base list-none bg-white rounded divide-y divide-gray-100 shadow-xl dark:bg-gray-800;
}

.phone-prefix-dropdown-area-footer {
    @apply z-50 my-4 w-48 text-base list-none rounded divide-y divide-gray-100 shadow-xl bg-gray-800;
}

.phone-prefix-dropdown-item {
    @apply block py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white;
}

.phone-prefix-dropdown-item-footer {
    @apply block py-2 px-4 text-sm text-gray-400 hover:bg-gray-600 hover:text-white;
}
</style>
